import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { galleryImages } from '../../data/productContent';
export function ProductGallery() {
  const [index, setIndex] = useState(0);
  const reduceMotion = useReducedMotion();
  const current = galleryImages[index];
  const go = (dir: number) => setIndex(i => (i + dir + galleryImages.length) % galleryImages.length);
  return <div role="region" aria-roledescription="gallery" aria-label="Product images" data-id="element-227" data-mp="340ktq42zjw78">
      <div className="relative flex aspect-square w-full items-center justify-center overflow-hidden rounded-md border border-line bg-surface" data-id="element-228" data-mp="2q0a1awm129jy">
        <AnimatePresence initial={false} data-id="element-229" data-mp="2u0k645y32tx8">
          <motion.div key={current.id} initial={reduceMotion ? false : {
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.22,
          ease: [0.23, 1, 0.32, 1]
        }} className="absolute inset-0 flex items-center justify-center p-6 md:p-10" data-id="element-230" data-mp="2u3pxjru6q7w4">
            <img src={current.src} alt={current.alt} className="max-h-full w-auto object-contain" style={{
            maxWidth: `min(${current.nativeWidth}px, 100%)`
          }} data-id="element-231" data-mp="28rwb3inapzkc" />
          </motion.div>
        </AnimatePresence>
        <button type="button" onClick={() => go(-1)} aria-label="Previous image" className="absolute left-3 top-1/2 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-line bg-surface text-ink transition-colors duration-150 ease-out hover:bg-canvas" data-id="element-232" data-mp="2woa59uv71iu1">
          <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-233" data-mp="31g1wm7m6bsl8" />
        </button>
        <button type="button" onClick={() => go(1)} aria-label="Next image" className="absolute right-3 top-1/2 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border border-line bg-surface text-ink transition-colors duration-150 ease-out hover:bg-canvas" data-id="element-234" data-mp="3fg2zttpwvc3v">
          <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-235" data-mp="2czixbp1ibzun" />
        </button>
      </div>

      <div className="mt-4 flex items-center justify-between gap-4" data-id="element-236" data-mp="2h1nomh4hgke4">
        <ul className="flex gap-3" aria-label="Choose image" data-id="element-237" data-mp="2lvrxx71814id">
          {galleryImages.map((img, i) => <li key={img.id} data-id="element-238" data-mp="2qt1ur7qxwig8" data-mpi={i}>
              <button type="button" onClick={() => setIndex(i)} aria-label={`Show ${img.label}`} aria-current={i === index ? 'true' : undefined} className={`block h-16 w-16 overflow-hidden rounded-[3px] border bg-surface transition-colors duration-150 ease-out ${i === index ? 'border-ink' : 'border-line hover:border-line-strong'}`} data-id="element-239" data-mp="2vseh7rdwfnia">
                <img src={img.src} alt="" className="h-full w-full object-cover" data-id="element-240" data-mp="1afbpvyrzxq5j" />
              </button>
            </li>)}
        </ul>
        <p aria-live="polite" className="hidden text-[13px] text-ink-muted sm:block" data-id="element-241" data-mp="y52iewymx3ce">
          {current.label}
        </p>
      </div>
    </div>;
}